import React from 'react';
import { VisuallyHidden } from '@radix-ui/react-visually-hidden';
import * as Dialog from '@radix-ui/react-dialog';

import { useAuth } from '@/features/auth-managment/model/auth-context';
import {
  Authorization,
  SmsConfirmation,
  EmailConfirmation,
  ResetPasswordEmail,
  CreatePasswordSms,
  ConfirmPasswordEmail,
  CreateRecoveryPassword,
} from '@/features/auth-managment/ui/steps';
import {
  StyledAlertDialogOverlay,
  StyledAlertDialogContent,
  DialogOptionsList,
  DialogScroll,
} from '@/features/auth-managment/styles';

type StepKey =
  | 'authorization'
  | 'sms-confirmation'
  | 'email-confirmation'
  | 'reset-password-email'
  | 'create-recovery-password'
  | 'confirm-password-email'
  | 'create-password-sms';

const DIALOG_TITLE_KEY = 'AuthManagementContent';

const MAP_STEPS: Record<StepKey, React.ReactNode> = {
  authorization: <Authorization />,
  'email-confirmation': <EmailConfirmation />,
  'reset-password-email': <ResetPasswordEmail />,

  'create-recovery-password': <CreateRecoveryPassword />,
  'sms-confirmation': <SmsConfirmation />,
  'create-password-sms': <CreatePasswordSms />,
  'confirm-password-email': <ConfirmPasswordEmail />,
};

const VALID_STEP_KEYS = Object.keys(MAP_STEPS) as StepKey[];

export const AuthManagementContent = () => {
  const { currentStep, handleClose, visible } = useAuth();
  const isValidStep = (VALID_STEP_KEYS as string[]).includes(currentStep);
  const stepComponent = isValidStep ? MAP_STEPS[currentStep as StepKey] : null;

  return (
    <>
      <DialogScroll open={visible}>
        <StyledAlertDialogOverlay open={visible} onClick={handleClose} />
        <StyledAlertDialogContent>
          <VisuallyHidden>
            <Dialog.Title>{DIALOG_TITLE_KEY}</Dialog.Title>
          </VisuallyHidden>
          {stepComponent}
        </StyledAlertDialogContent>
        <DialogOptionsList id="dialog-options-list" />
      </DialogScroll>
    </>
  );
};
